export const isHtmlContent = (content) => {
  if (!content) {
    return false;
  }
  const raw = String(content);
  return /<\s*\/?\s*[a-z][^>]*>/i.test(raw) || /&[a-zA-Z0-9#]+;/.test(raw);
};

export const stripHtml = (html) => {
  const container = document.createElement('div');
  container.innerHTML = html;
  return (container.textContent || container.innerText || '').trim();
};

export const getPreviewText = (message, maxLength = 140) => {
  if (!message) {
    return '';
  }
  const plain = isHtmlContent(message) ? stripHtml(message) : message;
  return plain.length > maxLength ? `${plain.slice(0, maxLength)}…` : plain;
};
